import React from 'react';

import { ToggleField } from '@dndbeyond/character-common-components/es';

import { SidebarSubheading } from '../../../../components/Sidebar';
import { ToggleInfo } from './typings';

interface Props {
    toggles: Array<ToggleInfo>;
    heading: React.ReactNode;
    description: string;
}

export default class PreferencesPaneTogglesField extends React.PureComponent<Props> {
    static defaultProps = {
        initiallyEnabled: false,
    };

    render() {
        const { heading, description, toggles } = this.props;

        if (!toggles.length) {
            return null;
        }

        return (
            <div className="ct-preferences-pane__field ct-preferences-pane__field--toggle">
                <div className="ct-preferences-pane__field-summary">
                    <SidebarSubheading className="ct-preferences-pane__field-heading">{heading}</SidebarSubheading>
                    {description && <div className="ct-preferences-pane__field-description">{description}</div>}
                </div>
                <div className="ct-preferences-pane__field-toggles">
                    {toggles.map((toggle, idx) => (
                        <div className="ct-preferences-pane__field-toggle" key={idx}>
                            <div className="ct-preferences-pane__field-input">
                                <ToggleField
                                    label={toggle.label}
                                    initiallyEnabled={toggle.initiallyEnabled}
                                    onChange={toggle.onChange}
                                    onChangePromise={toggle.onChangePromise}
                                />
                            </div>
                            <div className="ct-preferences-pane__field-label">{toggle.label}</div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }
}
